import { render } from "./client-selection-popup.vue?vue&type=template&id=c25f7ce0"
import script from "./client-selection-popup.vue?vue&type=script&lang=js"
export * from "./client-selection-popup.vue?vue&type=script&lang=js"

import "./client-selection-popup.vue?vue&type=style&index=0&id=c25f7ce0&lang=scss"
script.render = render

export default script